import React, { useState } from 'react';
import AdminNav from './AdminNav';
import { FaBars, FaTimes } from 'react-icons/fa';

export default function AdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#F5F5F5]">
      {/* Mobile/Tablet Admin Header - shown below main site header */}
      <div className="lg:hidden fixed top-[64px] left-0 right-0 bg-[#0A2540] shadow-md z-40 px-4 py-3 flex items-center justify-between">
        <h2 className="text-lg font-bold text-white">📊 Admin Panel</h2>
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-2 hover:bg-[#003d56] rounded-lg text-white"
          aria-label="Toggle menu"
        >
          {sidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Sidebar - Hidden on mobile by default, slides in when opened */}
      {/* Mobile sidebar */}
      <div
        className={`lg:hidden fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ top: '120px', height: 'calc(100vh - 120px)' }}
      >
        <AdminNav onClose={() => setSidebarOpen(false)} isMobile={true} />
      </div>
      
      {/* Desktop sidebar - always visible, fixed width */}
      <div className="hidden lg:block w-64 flex-shrink-0">
        <AdminNav onClose={() => {}} isMobile={false} />
      </div>

      {/* Overlay for mobile - closes sidebar when clicked */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          style={{ top: '120px' }}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="flex-1 pt-16 lg:pt-0">
        {children}
      </div>
    </div>
  );
}
